// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-btn {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: #060000;
  border: none;
  font-family: "Clash Display";
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .login-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .login-btn:hover:before {
    transform: scaleX(1); }
  .login-btn:hover {
    color: #FEFEFE; }

.lng-button {
  background-color: transparent;
  color: #FEFEFE;
  text-decoration: none;
  display: block;
  width: 100%;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer; }

.ticket-btn {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .ticket-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .ticket-btn:hover:before {
    transform: scaleX(1); }
  .ticket-btn:hover {
    color: #FEFEFE; }

.read-more {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .read-more:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .read-more:hover:before {
    transform: scaleX(1); }
  .read-more:hover {
    color: #FEFEFE; }

.details-btn {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .details-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .details-btn:hover:before {
    transform: scaleX(1); }
  .details-btn:hover {
    color: #FEFEFE; }

.speakers-btn {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .speakers-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .speakers-btn:hover:before {
    transform: scaleX(1); }
  .speakers-btn:hover {
    color: #FEFEFE; }

.news-btn {
  width: auto;
  padding: 12px 24px;
  background-color: #0b957e;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .news-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #c5f128;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .news-btn:hover:before {
    transform: scaleX(1); }
  .news-btn:hover {
    color: #FEFEFE; }

.newsletter-btn {
  width: 44px;
  height: 42px;
  background-color: #0b957e;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .newsletter-btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #c5f128;
    z-index: -1;
    transform: scaleX(0) scaleY(0);
    transform-origin: center;
    transition: transform 0.3s ease-in-out; }
  .newsletter-btn:hover:before {
    transform: scaleX(1) scaleY(1); }

.tab-btn {
  width: auto;
  height: 38px;
  gap: 8px;
  padding: 0 16px;
  border: 1px solid #c5f128;
  border-radius: 8px;
  background-color: transparent;
  color: #c5f128;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  cursor: pointer; }
  .tab-btn.active {
    background-color: #c5f128;
    color: black; }
  .tab-btn:hover {
    background-color: #c5f128;
    color: black; }

.speake-read-more {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: black;
  outline: none;
  border: none;
  font-family: "Clash Display";
  gap: 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .speake-read-more:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .speake-read-more:hover:before {
    transform: scaleX(1); }
  .speake-read-more:hover {
    color: #FEFEFE; }

.popup-close {
  width: 81px;
  height: 33px;
  background-color: #c5f128;
  color: black;
  outline: none;
  border: none;
  font-family: "Clash Display";
  gap: 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1; }
  .popup-close:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .popup-close:hover:before {
    transform: scaleX(1); }
  .popup-close:hover {
    color: #FEFEFE; }

.gallery-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #c5f128;
  border-radius: 100%;
  background-color: #c5f128;
  cursor: pointer;
  color: black; }
  .gallery-btn:hover {
    transform: scale(1.1);
    background: #0b957e; }

.open-gallery-btn {
  width: 46px;
  height: 46px;
  border: 1px solid rgba(215, 220, 77, 0.25);
  border-radius: 100%;
  background-color: #060000;
  cursor: pointer; }

.price-button {
  width: auto;
  padding: 12px 24px;
  background-color: #c5f128;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 10000;
  transition: background-color 0.3s, color 0.3s, transform 0.3s, box-shadow 0.3s; }
  .price-button:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0b957e;
    z-index: -1;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.5s ease-in-out; }
  .price-button:hover:before {
    transform: scaleX(1); }
  .price-button:hover {
    color: #FEFEFE;
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2); }

.price-button.disabled {
  cursor: auto;
  pointer-events: none;
  background-color: #2F2F2F;
  color: #929292; }

.accept-cookies-btn {
  width: 211px;
  height: 44px;
  background-color: #c5f128;
  color: #060000;
  outline: none;
  border: none;
  border-radius: 12px;
  font-family: "Clash Display";
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s; }
  .accept-cookies-btn:hover {
    background-color: #0b957e;
    color: #FEFEFE; }

@media screen and (max-width: 768px) {
  .tab-btn {
    font-size: 15px; } }
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.scss","webpack://./src/styles/Colors.scss"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBC8BmB;ED7BnB,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAbZ;IAgBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBC0BkB;IDzBlB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA1B1C;IA8BI,oBAAoB,EAAA;EA9BxB;IAkCI,cCdgB,EAAA;;ADmBpB;EACE,6BAA6B;EAC7B,cCrBkB;EDsBlB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,kBAAkB;EAClB,yBCtBoB;EDuBpB,cCnCkB;EDoClB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBC/BiB;IDgCjB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cCrEgB,EAAA;;AD0EpB;EACE,WAAW;EACX,kBAAkB;EAClB,yBC/DoB;EDgEpB,cC5EkB;ED6ElB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBCxEiB;IDyEjB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cC9GgB,EAAA;;ADmHpB;EACE,WAAW;EACX,kBAAkB;EAClB,yBCxGoB;EDyGpB,cCrHkB;EDsHlB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBCjHiB;IDkHjB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cCvJgB,EAAA;;AD4JpB;EACE,WAAW;EACX,kBAAkB;EAClB,yBCjJoB;EDkJpB,cC9JkB;ED+JlB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBC1JiB;ID2JjB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cChMgB,EAAA;;ADqMpB;EACE,WAAW;EACX,kBAAkB;EAClB,yBC9KmB;ED+KnB,cCvMkB;EDwMlB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBC/MkB;IDgNlB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cCzOgB,EAAA;;AD8OpB;EACE,WAAW;EACX,YAAY;EACZ,yBCvNmB;EDwNnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EATZ;IAYI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBChPiB;IDiPjB,WAAW;IACX,8BAA8B;IAC9B,wBAAwB;IACxB,sCAAsC,EAAA;EAtB1C;IA0BI,8BAA8B,EAAA;;AAKlC;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,yBC1OuB;ED2OvB,kBAAkB;EAClB,6BAA6B;EAC7B,cCpQiB;EDqQjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAA;EAZjB;IAeI,yBC3Qe;ID4Qf,YAAY,EAAA;EAhBhB;IAmBI,yBC/Qe;IDgRf,YAAY,EAAA;;AAIhB;EACE,WAAW;EACX,kBAAkB;EAClB,yBCzRsB;ED0RtB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBCjSkB;IDkSlB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cCzUgB,EAAA;;AD8UpB;EACE,WAAW;EACX,YAAY;EACZ,yBClUsB;EDmUtB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAA;EAfZ;IAkBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBC1UkB;ID2UlB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA5B1C;IAgCI,oBAAoB,EAAA;EAhCxB;IAoCI,cClXgB,EAAA;;ADsXpB;EACE,WAAW;EACX,YAAY;EACZ,yBCpWqB;EDqWrB,mBAAmB;EACnB,yBCtWqB;EDuWrB,eAAe;EACf,YAAY,EAAA;EAPd;IAUI,qBAAqB;IACrB,mBCrWkB,EAAA;;ADyWtB;EACE,WAAW;EACX,YAAY;EACZ,0CC7V0C;ED8V1C,mBAAmB;EACnB,yBCpXiC;EDqXjC,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,kBAAkB;EAClB,yBCnYoB;EDoYpB,cChZkB;EDiZlB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,8EAA8E,EAAA;EAhBhF;IAmBI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBC7YiB;ID8YjB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,sCAAsC,EAAA;EA7B1C;IAiCI,oBAAoB,EAAA;EAjCxB;IAqCI,cCnbgB;IDobhB,sBAAsB;IACtB,yCAAyC,EAAA;;AAI7C;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,cAAc,EAAA;;AAKhB;EACE,YAAY;EACZ,YAAY;EACZ,yBCvboB;EDwbpB,cCpckB;EDqclB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6CAA6C,EAAA;EAb/C;IAgBI,yBCxbiB;IDybjB,cCndgB,EAAA;;ADudpB;EACE;IACE,eAAe,EAAA,EAChB","sourcesContent":["@import \"../../styles/Colors.scss\";\n\n.login-btn {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $loginButton;\n  color: #060000;\n  border: none;\n  font-family: \"Clash Display\";\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton2;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.lng-button {\n  background-color: transparent;\n  color: $whiteColor;\n  text-decoration: none;\n  display: block;\n  width: 100%;\n  border: none;\n  background: none;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ticket-btn {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $yellowButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.read-more {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $yellowButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.details-btn {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $yellowButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.speakers-btn {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $yellowButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.news-btn {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $hoverButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $yellowButton;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.newsletter-btn {\n  width: 44px;\n  height: 42px;\n  background-color: $hoverButton;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $inputButton;\n    z-index: -1;\n    transform: scaleX(0) scaleY(0);\n    transform-origin: center;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1) scaleY(1);\n  }\n}\n\n\n.tab-btn {\n  width: auto;\n  height: 38px;\n  gap: 8px;\n  padding: 0 16px;\n  border: 1px solid $tabButtonBorder;\n  border-radius: 8px;\n  background-color: transparent;\n  color: $tabButton;\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 400;\n  cursor: pointer;\n\n  &.active {\n    background-color: $tabButton;\n    color: black;\n  }\n  &:hover {\n    background-color: $tabButton;\n    color: black;\n  }\n}\n\n.speake-read-more {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $speakersButton;\n  color: black;\n  outline: none;\n  border: none;\n  font-family: \"Clash Display\";\n  gap: 32px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton2;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n\n.popup-close {\n  width: 81px;\n  height: 33px;\n  background-color: $speakersButton;\n  color: black;\n  outline: none;\n  border: none;\n  font-family: \"Clash Display\";\n  gap: 32px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton2;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n  }\n}\n\n.gallery-btn{\n  width: 32px;\n  height: 32px;\n  border: 1px solid $galleryButton;\n  border-radius: 100%;\n  background-color: $galleryButton;\n  cursor: pointer;\n  color: black;\n\n  &:hover {\n    transform: scale(1.1) ;\n    background: $hoverButton2;\n  }\n}\n\n.open-gallery-btn{\n  width: 46px;\n  height: 46px;\n  border: 1px solid $openGalleryBorder;\n  border-radius: 100%;\n  background-color: $openGalleryButton;\n  cursor: pointer;\n}\n\n.price-button {\n  width: auto;\n  padding: 12px 24px;\n  background-color: $yellowButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  z-index: 10000;\n  transition: background-color 0.3s, color 0.3s, transform 0.3s, box-shadow 0.3s;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: $hoverButton;\n    z-index: -1;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition: transform 0.5s ease-in-out;\n  }\n\n  &:hover:before {\n    transform: scaleX(1);\n  }\n\n  &:hover {\n    color: $whiteColor;\n    transform: scale(1.05);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  }\n}\n\n.price-button.disabled{\n  cursor: auto;\n  pointer-events: none;\n  background-color: #2F2F2F;\n  color: #929292;\n}\n\n\n\n.accept-cookies-btn {\n  width: 211px;\n  height: 44px;\n  background-color: $yellowButton;\n  color: $textColor2;\n  outline: none;\n  border: none;\n  border-radius: 12px;\n  font-family: \"Clash Display\";\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s; \n\n  &:hover {\n    background-color: $hoverButton;\n    color: $whiteColor;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .tab-btn {\n    font-size: 15px;\n  }\n}\n\n","//background\n$primaryBackground: #0A0019;\n$navBackground: rgba(6, 0, 0, 0.7);\n$cookiesBackground: linear-gradient(180deg, #0A0019 0%, #36004B 34.88%, #300A2C 55.5%, #390B30 73.31%, #0A0019 100%);\n$backgroundBox: #fff2e6;\n$backgroundBoxes: #0c2323;\n$backgroundDotsActive: #c5f128;\n$socialCircleBg: #E8C5B0;\n$yellowBackground: #0b957e;\n$partnerCardBackground:#150d24;\n$galleryTextBackground: rgba(255, 255, 255, 0.05);\n$galleryPopupBackground: rgba(10, 0, 25, 1);\n$gradientBackground: linear-gradient(96.43deg, #0A0019 0%, #130926 18%, #0A0019 36.5%, #1A0044 53%, #0A0019 71%, #0A001C 100%);\n$cardBackgorund: linear-gradient(180deg, #0A0019 0%, #36004B 34.88%, #300A2C 55.5%, #390B30 73.31%, #0A0019 100%);\n$newsletterBackground: linear-gradient(90deg, #0A001C 0%, #1A0044 30%, #120031 52.5%, #1A0044 76.5%, #0A0019 100%);\n$conferenceBoxBackground: linear-gradient(180deg, #0A0019 0%, #36004B 34.88%, #300A2C 55.5%, #390B30 73.31%, #0A0019 100%);\n$priceCardBackground: linear-gradient(180deg, #0A0019 0%, #36004B 34.88%, #300A2C 55.5%, #390B30 73.31%, #0A0019 100%);\n\n$hoverCardBackground: rgba(238, 238, 238, 0.15);\n\n\n//text colors\n$whiteColor: #FEFEFE;\n$activeColor: #c5f128;\n$textColor2: #060000;\n$textColor3: #53C2B4;\n$textColor4: rgba(146, 146, 146, 1);\n$textColor5: #0b957e;\n$textColor6: rgba(238, 238, 238, 1);\n$textColor7: #c5f128;\n$textColor8: rgba(156, 216, 213, 1);\n$textColor9: rgba(210, 149, 194, 1);\n\n\n//buttons\n$loginButton: #c5f128;\n$yellowButton: #c5f128;\n$speakersButton: #c5f128;\n$inputButton: #c5f128;\n$tabButton: #c5f128;\n$controlButton: #929292;\n$controlGalleryButton: rgba(146, 146, 146, 1);\n$controlButtonBg: #EEEEEE;\n$galleryButton: #c5f128;\n$openGalleryButton:rgba(6, 0, 0, 1);\n\n//hover buttons\n\n$hoverButton: #0b957e;\n\n$hoverButton2: #0b957e;\n\n\n//border\n$borderLine: #c5f128;\n$cardBorder: rgba(98, 13, 146, 1);\n$partnerBorder: rgba(174, 82, 159, 1);\n$platinumPartnerBorder: rgba(238, 238, 238, 1);\n$goldPartnerBorder: rgba(215, 220, 77, 1);\n$silverPartnerBorder: rgba(146, 146, 146, 1);\n$bronzedPartnerBorder: rgba(83, 194, 180, 1);\n$friendPartnerBorder: rgba(156, 216, 213, 1);\n$tabButtonBorder: #c5f128;\n$silverBorder: rgba(146, 146, 146, 1);\n$cianBorder: rgba(83, 194, 180, 1);\n$openGalleryBorder: rgba(215, 220, 77, 0.25);\n$galleryTitleBorder: rgba(255, 255, 255, 0.15);\n\n\n//box shadow\n$boxShadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;\n$boxShadow1: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px,\n  rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;\n$boxShadow2: rgba(0, 0, 0, 0.04) 0px 3px 5px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
